"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _some2 = _interopRequireDefault(require("lodash/some"));

var _reactQuery = require("react-query");

var _fetchWithAuth = _interopRequireDefault(require("../services/fetchWithAuth"));

var useFetch = function useFetch(accessToken) {
  for (var _len = arguments.length, urls = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    urls[_key - 1] = arguments[_key];
  }

  return (0, _reactQuery.useQuery)(['fetchLinks', accessToken, urls], function () {
    if (urls.length > 1) {
      return Promise.all(urls.map(function (url) {
        return (0, _fetchWithAuth["default"])({
          accessToken: accessToken,
          endpointUrl: url
        });
      }));
    }

    return (0, _fetchWithAuth["default"])({
      accessToken: accessToken,
      endpointUrl: urls[0]
    });
  }, {
    retry: false,
    enabled: (0, _some2["default"])(urls)
  });
};

var _default = useFetch;
exports["default"] = _default;